<template>
    <Drawer :title="andamento.titulo" placement="right" 
            width="850" :before-close="closeDrawerTicket" 
            :value="value" @input="v => $emit('input', v)">
        <PgdFormCausas ref="form" :andamento="andamento" v-on:input="emitForm" v-if="value">
        </PgdFormCausas>        
    </Drawer>
</template>

<script>

export default {
    props:[
        'andamento',
        'value',
    ],
    methods:{
       emitForm(form){
            this.$emit("update", form);
        },
        // pergunta ao usuario se ele realmente quer fechar o componete sem salvar as alterações
        closeDrawerTicket() {
                return new Promise((resolve) => {
                    if (this.$refs.form.mostrar_botao) {
                        this.$Modal.confirm({
                            title: 'Há alterações que não foram salvas.',
                            content: 'Deseja realmente fechar?',
                            cancelText: "Não",
                            okText: "Sim",
                            onOk: () => {
                                resolve();
                            },
                        });
                    } else {
                        resolve();
                    }
                });
            },
    }
    
}
</script>
